import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import { BASE_PATH } from "src/config/constants";
import { authHeader } from "src/utils/authHeader";

export const apiInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API}/api`,
});

// Add a request interceptor
apiInstance.interceptors.request.use(async (config) => {
  const token = authHeader()

  if (token) config.headers.Authorization = `${token}`;

  return config;
});

// Add a response interceptor
apiInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    // Handle 401 errors
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = `${BASE_PATH}/login`;
    }
    return Promise.reject(error);
  }
);

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await apiInstance.get(url, { ...config });

  return res.data;
};

export default apiInstance;
